export function buildQueryParams(queryParams) {
  if (!Array.isArray(queryParams)) {
    queryParams = []
  }
  return (queryParams.length > 0 ? `?${queryParams.join("&")}` : '')
}
